module.exports = __webpack_public_path__ + "img/banner.c45db043.jpg";